<template>
  <div
    class="page-container page-container--height chat-visible"
    v-if="loggedIn"
    :class="{'sidebar-collapsed--chat' : sidebarStateRight, 'sidebar-collapsed' : sidebarStateLeft}"
  >
    <app-left-panel></app-left-panel>
    <app-conversation :is-fetch="isFetch"></app-conversation>
    <app-right-panel></app-right-panel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RightPanel from './RightPanel.vue';
import LeftPanel from './LeftPanel.vue';
import Conversation from './Conversation.vue';

export default {
  data: function() {
    return {
      isFetch: false,
    };
  },
  computed: {
    ...mapGetters([
      'loggedIn',
      'loggedInHash',
      'sidebarStateLeft',
      'sidebarStateRight',
      'userData',
    ]),
  },
  components: {
    appRightPanel: RightPanel,
    appLeftPanel: LeftPanel,
    appConversation: Conversation,
  },
  created() {
    setTimeout(this.loadPersonalChat, 100);
    // this.loadPersonalChat();
  },
  methods: {
    loadPersonalChat() {
      if (this.userData === null) return;

      this.isFetch = true;
      this.$store.commit('CLEAR_MESSAGES');
      this.$store.dispatch('personal_channel', this.$route.params.id).then(
        res => {
          let ids = [];
          let includesMe = res.data.data.members.forEach(item => {
            ids.push(item.id);
          });

          if (!ids.includes(this.userData?.id) || ids.length === 0) {
            this.$router.push({ name: 'dashboard' });
          }

          this.isFetch = false;
        },
        err => {
          console.log(err, 'error');
          this.isFetch = false;

          if (
            err.message &&
            (err.message === 'cancel before fetch personal_channel' ||
              err.message === 'cancel before fetch channel')
          )
            return;

          this.$router.push({ name: 'dashboard' });
        },
      );
    },
  },
  watch: {
    loggedInHash: function(val) {
      if (!this.loggedIn) {
        this.$router.push({ name: 'login' });
      }
    },
    $route() {
      this.loadPersonalChat();
    },
    userData: 'loadPersonalChat',
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
  .page-container.sidebar-collapsed {
    background-color: #fff;

    & ::v-deep .sidebar-menu {
      width: auto;
      min-width: auto;

      .logo-env > div.sidebar-collapse {
        left: 0;
      }

      #main-menu > li > a span {
        display: none;
      }

      & + .main-content .comment {
        left: 85px;
        width: calc(100% - 385px);
      }
    }

    & ::v-deep .aside-menu__icon {
      margin-right: 0;
    }
    
    .main-content--wide {
      width: calc(100% - 65px) !important;
      margin-left: 65px;
    }
  }
}
</style>

